module.exports = __webpack_public_path__ + "img/item-1.4cd9bc8.png";